var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { height: "100%" } }, [
    _vm.loading
      ? _c("div", [_c("loading", { attrs: { show: _vm.loading } })], 1)
      : _c("div", { staticStyle: { position: "relative", height: "100%" } }, [
          !_vm.valid
            ? _c("div", {}, [
                _c(
                  "div",
                  {
                    staticClass: "font-20",
                    staticStyle: {
                      position: "fixed",
                      top: "50%",
                      left: "50%",
                      color: "#000",
                      transform: "translate(-50%, -50%)"
                    }
                  },
                  [_vm._v("数据无效")]
                )
              ])
            : _c(
                "div",
                { staticStyle: { height: "100%" } },
                [
                  _c(
                    "swiper",
                    {
                      ref: "postureSwiper",
                      attrs: { options: _vm.swiperOption }
                    },
                    [
                      _c("swiper-slide", { staticClass: "pagintaion-space" }, [
                        _c("div", {
                          staticStyle: { height: "100%", overflow: "hidden" },
                          attrs: { id: "face" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "swiper-pagination posture-swiper-pagination content-row content-row-around",
                        attrs: { slot: "pagination" },
                        slot: "pagination"
                      })
                    ],
                    1
                  )
                ],
                1
              )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-189be7e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-189be7e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Face.vue
// module id = null
// module chunks = 